import { render, staticRenderFns } from "./AssetForm.vue?vue&type=template&id=6e811371&scoped=true&"
import script from "./AssetForm.vue?vue&type=script&lang=js&"
export * from "./AssetForm.vue?vue&type=script&lang=js&"
import style0 from "./AssetForm.vue?vue&type=style&index=0&id=6e811371&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e811371",
  null
  
)

export default component.exports